import { ChangeDetectionStrategy, Component, forwardRef, InputSignal, input, ViewEncapsulation, inject, DestroyRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CheckboxModule } from 'primeng/checkbox';
import { CheckboxConfig } from '../_config/input.model';

@Component({
  selector: 'plyca-ui-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PlycaUiCheckboxComponent),
      multi: true
    }
  ],
  imports: [CheckboxModule, ReactiveFormsModule]
})
export class PlycaUiCheckboxComponent implements ControlValueAccessor {
  public config: InputSignal<CheckboxConfig> = input.required<CheckboxConfig>();
  public control = new FormControl<boolean>(false);

  private readonly _destroyRef = inject(DestroyRef);

  private onChange: (value: boolean) => void = () => {};

  constructor() {
    this.control?.valueChanges.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((val) => this.onChange(!!val));
  }

  onTouched: () => void = () => {};

  writeValue(val: boolean): void {
    this.control.setValue(!!val, { emitEvent: false });
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    void (isDisabled ? this.control.disable() : this.control?.enable());
  }
}
